var _style, _g, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoIconOutrun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "logo-icon-outrun_svg__Layer_1",
    viewBox: "0 0 188 188",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-icon-outrun_svg__g57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-icon-outrun_svg__g55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-icon-outrun_svg__g53"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-icon-outrun_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.43,
    y1: -5.43,
    x2: 127.48,
    y2: 61.62,
    gradientTransform: "matrix(1 0 0 -1 0 188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "logo-icon-outrun_svg__stop4",
    stopColor: "#ffff7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    id: "logo-icon-outrun_svg__stop6",
    stopColor: "#ff22b3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 34.8,167 h 118.4 c 2.7,-2.2 5.4,-4.6 7.8,-7.1 H 26.9 c 2.5,2.5 5.1,4.9 7.9,7.1 z",
    id: "logo-icon-outrun_svg__path9",
    fill: "url(#logo-icon-outrun_svg__SVGID_1_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-icon-outrun_svg__SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.825,
    y1: -9.925,
    x2: 121.075,
    y2: 44.325,
    gradientTransform: "matrix(1 0 0 -1 0 188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "logo-icon-outrun_svg__stop11",
    stopColor: "#ffff7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    id: "logo-icon-outrun_svg__stop13",
    stopColor: "#ff22b3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 136.4,177.9 c 4.1,-2.1 8.1,-4.5 11.8,-7.1 H 39.7 c 3.8,2.7 7.7,5 11.8,7.1 z",
    id: "logo-icon-outrun_svg__path16",
    fill: "url(#logo-icon-outrun_svg__SVGID_2_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-icon-outrun_svg__SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.05,
    y1: 0.45,
    x2: 132.95,
    y2: 78.35,
    gradientTransform: "matrix(1 0 0 -1 0 188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "logo-icon-outrun_svg__stop18",
    stopColor: "#ffff7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    id: "logo-icon-outrun_svg__stop20",
    stopColor: "#ff22b3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 22.4,154.9 h 143.2 c 1.9,-2.3 3.8,-4.7 5.5,-7.1 H 16.9 c 1.7,2.4 3.5,4.8 5.5,7.1 z",
    id: "logo-icon-outrun_svg__path23",
    fill: "url(#logo-icon-outrun_svg__SVGID_3_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-icon-outrun_svg__SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.45,
    y1: -10.95,
    x2: 112.59,
    y2: 26.19,
    gradientTransform: "matrix(1 0 0 -1 0 188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "logo-icon-outrun_svg__stop25",
    stopColor: "#ffff7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    id: "logo-icon-outrun_svg__stop27",
    stopColor: "#ff22b3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 56.9,180.4 c 11.4,4.9 23.9,7.6 37.1,7.6 13.2,0 25.7,-2.7 37.1,-7.6 z",
    id: "logo-icon-outrun_svg__path30",
    fill: "url(#logo-icon-outrun_svg__SVGID_4_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-icon-outrun_svg__SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.5,
    y1: 10.5,
    x2: 136.85,
    y2: 97.85,
    gradientTransform: "matrix(1 0 0 -1 0 188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "logo-icon-outrun_svg__stop32",
    stopColor: "#ffff7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    id: "logo-icon-outrun_svg__stop34",
    stopColor: "#ff22b3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 12.2,140.2 h 163.7 c 1.3,-2.4 2.6,-4.8 3.7,-7.3 L 7.4,130.5 c 1.4,3.4 3,6.6 4.8,9.7 z",
    id: "logo-icon-outrun_svg__path37",
    fill: "url(#logo-icon-outrun_svg__SVGID_5_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-icon-outrun_svg__SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.8,
    y1: 24.8,
    x2: 143.2,
    y2: 123.2,
    gradientTransform: "matrix(1 0 0 -1 0 188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "logo-icon-outrun_svg__stop39",
    stopColor: "#ffff7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    id: "logo-icon-outrun_svg__stop41",
    stopColor: "#ff22b3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 1.1,108.5 c 0.8,4.9 1.9,9.7 3.4,14.4 h 179 c 1.5,-4.6 2.6,-9.4 3.4,-14.4 z",
    id: "logo-icon-outrun_svg__path44",
    fill: "url(#logo-icon-outrun_svg__SVGID_6_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-icon-outrun_svg__SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.894,
    y1: 52.606,
    x2: 152.106,
    y2: 168.819,
    gradientTransform: "matrix(1 0 0 -1 0 188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "logo-icon-outrun_svg__stop46",
    stopColor: "#ffff7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    id: "logo-icon-outrun_svg__stop48",
    stopColor: "#ff22b3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 187.8,99.7 C 187.9,97.8 188,95.9 188,94 188,42.1 145.9,0 94,0 42.1,0 0,42.1 0,94 c 0,1.9 0.1,3.8 0.2,5.7 z",
    id: "logo-icon-outrun_svg__path51",
    fill: "url(#logo-icon-outrun_svg__SVGID_7_)"
  }))))), /*#__PURE__*/React.createElement("g", {
    "aria-label": "FC",
    style: {
      lineHeight: 1.25,
      InkscapeFontSpecification: "'outrun future, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start"
    },
    id: "logo-icon-outrun_svg__text877",
    transform: "translate(-6.861 -6.528)",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 86.867,
    fontFamily: "outrun future",
    letterSpacing: 0,
    wordSpacing: 0,
    writingMode: "lr-tb",
    textAnchor: "start",
    fill: "#04d5fb",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 2.172
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 109.28081,57.688561 v 0.5514 l -2.58734,0.296908 v 0.296908 h 2.29043 v 0.551401 q -1.61179,1.230047 -15.990616,5.429174 -5.47159,2.587341 -16.838924,5.726083 L 70.725186,82.544 l 0.5514,-0.296908 h 8.016516 q 6.319898,0 17.98414,-0.848308 v 0.5514 q -0.721062,0 -2.290433,0.296908 V 82.544 h 2.290433 v 0.551401 q -1.823863,1.145216 -15.990615,5.429174 v 0.296908 h 1.145216 v 0.551401 h -0.593816 v 0.296908 h 0.890724 V 89.9667 q -1.187632,1.314878 -13.44569,8.271007 -8.5255,2.078353 -8.567915,2.841833 -7.295454,15.35438 -13.997091,24.00713 -2.544925,2.4601 -13.99709,18.28105 h -0.296908 l -0.848309,-0.5514 q 0,0.25449 -0.296907,0.25449 l -0.551401,-1.99352 q 4.283958,-17.3055 10.264533,-31.98123 13.742598,-31.048095 13.99709,-32.871958 -0.636231,0 -1.145216,-1.993525 l -1.102801,0.593816 q -1.314879,-0.551401 -1.442125,-1.145217 0.296908,-0.508985 0.296908,-1.145216 -0.890724,0 -0.890724,-0.848309 1.654202,-7.422699 7.465115,-7.422699 3.690142,-1.187632 3.690142,-2.587341 h 1.145217 l 1.145216,0.848308 q 0.593816,-1.145216 1.442124,-1.145216 l 1.993525,0.296908 q 1.187632,0 3.43565,-1.696617 h 0.848308 q 0.551401,0.08483 0.551401,0.5514 8.652747,-1.654201 36.859007,-2.841833 z",
    id: "logo-icon-outrun_svg__path879"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 159.5855,58.324792 q 4.19913,0 9.6283,3.520481 l -0.33932,0.508985 v 0.254492 q 1.39971,0.127247 1.39971,0.763478 -0.33932,0.46657 -0.33932,0.763478 0.50898,0 1.06038,0.763477 l -0.72106,0.975555 0.72106,0.254493 q -0.93314,6.277483 -12.80946,19.426264 -0.89072,0 -2.50251,1.017971 h -0.72106 q -0.72106,0 -0.72106,-0.763478 h -0.33932 l -1.44213,1.01797 q 0,-0.890724 -2.84183,-1.272463 l -0.33933,-0.508985 -0.72106,0.254493 h -2.84183 q 0,-0.424154 -2.50251,-1.230048 l -2.12077,-3.817388 q 0.67864,0 1.06038,-2.50251 0.72107,0 2.84184,-2.799418 h -0.33933 q -6.27748,2.799418 -11.07042,6.065406 -1.9087,0 -16.7541,13.106366 -12.25805,15.863369 -13.86984,26.000659 v 0.76347 q 0.72106,0.0848 0.72106,0.50899 -0.72106,0.0848 -0.72106,0.50898 1.06039,0 2.12077,4.02947 0,0.25449 0.72106,0.25449 1.61179,0 12.80946,-4.28396 8.5255,-1.78144 17.13583,-5.30192 h 0.33933 l -1.06039,0.97555 h 0.33932 l 1.06039,-0.46657 h 0.38174 q 0,0.89073 -1.78145,2.757 l 1.39971,-0.50898 v 0.25449 l -1.06039,1.27246 h 0.38174 l 1.39971,-0.76347 h 0.38174 q -3.43565,8.35584 -26.04307,17.13583 -4.45362,1.52695 -11.02801,1.52695 -10.94318,0 -15.311969,-10.85834 -0.721062,-2.12078 -0.721062,-5.55643 v -1.99352 q 0,-19.34143 32.405381,-45.426921 16.88134,-10.985595 32.4478,-15.099891 6.5744,-1.526956 10.30695,-1.526956 z",
    id: "logo-icon-outrun_svg__path881"
  }))));
}

export default SvgLogoIconOutrun;